import { datadogRum } from '@datadog/browser-rum';
import { useEffect, useRef } from 'react';
import { NEW_CARS_DATADOG_EVENTS } from '~/constants/new-cars/datadogEvents';
import findMissingImages, {
  type ImageGroup
} from '~/utilities/new-cars/findMissingImages';

type OwnArgs = {
  groups: ImageGroup[];
  isLoaded: boolean;
  vehicle: string;
};

export default function useReportMissingImages({
  groups,
  isLoaded,
  vehicle
}: OwnArgs) {
  const lastReportedKey = useRef('');

  const missingImages = findMissingImages(groups);
  const key = JSON.stringify([vehicle, missingImages]);

  useEffect(() => {
    if (!isLoaded || missingImages.length === 0) return;
    if (lastReportedKey.current === key) return;

    lastReportedKey.current = key;
    datadogRum.addAction(NEW_CARS_DATADOG_EVENTS.CONFIGURATOR_IMAGE_FALLBACK, {
      missingCount: missingImages.length,
      missingImages,
      sections: [...new Set(missingImages.map(({ section }) => section))],
      vehicle
    });
  }, [isLoaded, key, missingImages, vehicle]);
}
